import { Button } from '@chakra-ui/react';
import { useLocale, useToggleLocale } from '@/i18n/useLanguage';

const LanguageToggle = () => {
	const locale = useLocale();
	const toggleLocale = useToggleLocale();

	return (
		<Button
			onClick={toggleLocale}
			size="sm"
			variant="ghost"
			rounded="full"
			fontWeight="700"
			fontSize="xs"
			letterSpacing="wide"
			minW="48px"
			aria-label={locale === 'en' ? 'Byt till svenska' : 'Switch to English'}
			title={locale === 'en' ? 'Svenska' : 'English'}
		>
			{locale === 'en' ? 'EN' : 'SV'}
		</Button>
	);
};

export default LanguageToggle;
